<template>
  <nx-list :items="formattedItems" bag clipboard @click:item="handleClick" title-one-line selectable>
    <template #item-actions="props">
      <nx-bag-item-actions :item="props.item"
                           deletable
                           renameable
                           cloneable
                           :moveable="!publicClipboard"
                           :multisite-shareable="props.item.isMultisiteShareable"
                           @click:clone="handleClone"
                           @click:move="handleMove"
                           @click:multisite="handleMultisite"
                           @click:delete="handleDelete" />
    </template>
  </nx-list>
</template>

<script>
import { mapGetters } from 'vuex';
import NxList from '@/components/list/List';
import NxBagItemActions from '@/modules/bag/components/common/BagListItemActions';
import { capitalize } from '@/filters';

export default {
  name: 'nx-bag-clipboard-list',
  components: {
    NxList,
    NxBagItemActions,
  },
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    publicClipboard: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('bag/clipboard', ['moduleConfig']),
    formattedItems() {
      return this.items.map(item => ({
        id: item.id,
        image: this.getImage(item),
        uuid: item.uuid,
        title: capitalize(this.getTitle(item)),
        subtitle: this.getType(item),
        icon: {
          name: this.getIcon(item),
        },
        type: this.getType(item),
        isMultisiteShareable: this.isMultisiteShareable(item),
        chips: this.getChips(item),
      }));
    },
  },
  methods: {
    isMultisiteShareable(item) {
      if (item.sourceSiteAlias !== undefined) {
        return false; // Already converted to multisite module
      }
      const moduleConfig = this.moduleConfig(item.type);
      if (moduleConfig.multisiteShareable !== undefined) {
        return moduleConfig.multisiteShareable;
      }
      return false;
    },
    getChips(item) {
      const chips = [];
      if (item.sourceSiteAlias) {
        chips.push(
          {
            color: 'blue',
            textColor: 'white',
            tooltip: 'metadata.site',
            value: item.sourceSiteAlias,
          },
        );
      }
      return chips;
    },
    handleClick(formattedItem) {
      this.$emit('click:item', this.items.find(i => i.uuid === formattedItem.uuid));
    },
    handleMove(formattedItem) {
      this.$emit('click:move', this.items.find(i => i.uuid === formattedItem.uuid));
    },
    handleMultisite(formattedItem) {
      this.$emit('click:multisite', this.items.find(i => i.uuid === formattedItem.uuid));
    },
    handleClone(formattedItem) {
      this.$emit('click:clone', this.items.find(i => i.uuid === formattedItem.uuid));
    },
    handleDelete(formattedItem) {
      this.$emit('click:delete', this.items.find(i => i.uuid === formattedItem.uuid));
    },
    getTitle(item) {
      if (item.clipboardTitle) {
        return item.clipboardTitle;
      }
      if (item.fields
        && item.fields.title) {
        return item.fields.title;
      }
      if (item.fields
         && item.fields.kickerTitle) {
        return item.fields.kickerTitle;
      }
      if (item.alias) {
        return item.alias;
      }
      return this.getType(item);
    },
    getType(item) {
      // Try to translate composition modules first
      const config = this.moduleConfig(item.type);
      if (config) {
        return this.$te(config.name) ? this.$t(config.name) : config.name;
      }
      return this.$te(item.type) ? this.$t(item.type) : item.type;
    },
    getImage(item) {
      const config = this.moduleConfig(item.type);
      if (config) {
        return { src: config.thumbnail, aspectRatio: 4 / 3 };
      }
      return undefined;
    },
    getIcon(item) {
      if (item.type === 'modules.content') {
        return 'text_fields';
      }
      return 'view_quilt';
    },
  },
};
</script>
